export class PreChatFormView {
	constructor(state, options = {}) {
		this.state = state;
		this.options = options;
		this.element = null;
		this._isSubmitting = false;
	}

	render() {
		this.element = document.createElement('div');
		this.element.className = 'liveChat-view liveChat-prechat-view';
		this._updateContent();
		return this.element;
	}

	_isNameRequired() {
		return this.state.allowAnonymousChat === false;
	}

	_updateContent() {
		const nameRequired = this._isNameRequired();
		const namePlaceholder = nameRequired ? 'Your name' : 'Your name (optional)';
		const subtitle = nameRequired
			? 'Enter your name and email so we can get back to you.'
			: 'Enter your email so we can get back to you.';

		this.element.innerHTML = `
			<div class="liveChat-prechat-overlay">
				<div class="liveChat-prechat-card">
					<h4 class="liveChat-prechat-title">Before we continue</h4>
					<p class="liveChat-prechat-subtitle">${subtitle}</p>
					<form class="liveChat-prechat-form" novalidate>
						<div class="liveChat-prechat-field">
							<input
								type="text"
								name="name"
								class="liveChat-prechat-input"
								placeholder="${namePlaceholder}"
								autocomplete="name"
								${nameRequired ? 'required' : ''}
							/>
						</div>
						<div class="liveChat-prechat-field">
							<input
								type="email"
								name="email"
								class="liveChat-prechat-input"
								placeholder="Your email address"
								autocomplete="email"
								required
							/>
						</div>
						<span class="liveChat-prechat-error" style="display:none;"></span>
						<button type="submit" class="liveChat-prechat-submit">
							Start chat
						</button>
					</form>
				</div>
			</div>
		`;

		this._attachEvents();
	}

	_attachEvents() {
		const form = this.element.querySelector('.liveChat-prechat-form');
		form.addEventListener('submit', async (e) => {
			e.preventDefault();
			await this._handleSubmit();
		});
	}

	_validate(nameRequired, name, email) {
		if (nameRequired && !name) return { msg: 'Please enter your name.', field: 'name' };
		if (!email) return { msg: 'Please enter your email address.', field: 'email' };
		if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
			return { msg: 'Please enter a valid email address.', field: 'email' };
		}
		return null;
	}

	async _handleSubmit() {
		if (this._isSubmitting) return;

		const emailInput = this.element.querySelector('input[name="email"]');
		const nameInput = this.element.querySelector('input[name="name"]');
		const errorEl = this.element.querySelector('.liveChat-prechat-error');
		const submitBtn = this.element.querySelector('.liveChat-prechat-submit');

		const email = emailInput.value.trim();
		const name = nameInput.value.trim();
		const nameRequired = this._isNameRequired();

		const error = this._validate(nameRequired, name, email);
		if (error) {
			errorEl.textContent = error.msg;
			errorEl.style.display = 'block';
			(error.field === 'name' ? nameInput : emailInput).focus();
			return;
		}

		errorEl.style.display = 'none';
		this._isSubmitting = true;
		submitBtn.disabled = true;
		submitBtn.innerHTML = `
			<iconify-icon icon="ph:circle-notch" width="16" height="16" style="animation: spin 0.8s linear infinite;"></iconify-icon>
			Just a moment...
		`;

		try {
			if (this.options.onIdentifyContact) {
				await this.options.onIdentifyContact({
					name: name || undefined,
					email: email || undefined,
				});
			}

			this.state.setIdentified(true, { name, email });

			const pendingMessage = this.state.pendingMessage;
			if (pendingMessage && this.options.onStartConversation) {
				this.state.pendingMessage = null;
				this.state.setView('chat');
				await this.options.onStartConversation(
					pendingMessage.content,
					pendingMessage.attachments
				);
			} else {
				this.state.setView('chat');
			}
		} catch (error) {
			console.error('[PreChatFormView] Error:', error);
			errorEl.textContent = 'Something went wrong. Please try again.';
			errorEl.style.display = 'block';
			this._isSubmitting = false;
			submitBtn.disabled = false;
			submitBtn.textContent = 'Start chat';
		}
	}

	destroy() {
		if (this.element && this.element.parentNode) {
			this.element.parentNode.removeChild(this.element);
		}
	}
}
